export const isHostLocalhost = () => window.location.hostname === 'localhost';
export const getRedirectUri = (path: string) => {
  let redirectPrefix = window.location.origin;
  if (!isHostLocalhost()) {
    redirectPrefix += '/metadata';
  }

  return redirectPrefix + path;
};
